/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import differenceInSeconds from 'date-fns/difference_in_seconds';
import gatewayActions from 'loraactions/gateway';
import Refresher from 'loracoms/Refresher';
import DetailEye from 'loracoms/DetailEye';
import DataDirSwitch from 'loracoms/DataDirSwitch';
import RichLabel from 'loracoms/RichLabel';
import CollapseToggle from 'loracoms/CollapseToggle';
import PanelToolbar from 'loracoms/PanelToolbar';
import Link from 'loracoms/Link';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { compactFormat } from 'lorautils/DateTimeUtils';
import {
  normalizeAppEUI,
  normalizeDevEUI,
} from 'lorautils/IdUtils';
import styles from './styles.scss';


function isNew(time) {
  return differenceInSeconds(new Date(), time) < 10;
}

const propTypes = {
  getGatewayData: React.PropTypes.func.isRequired,
  gatewayData: React.PropTypes.object.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class BriefGatewayData extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gatewayData: props.gatewayData,
      dir: 'up',
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.detailview');
    this.handleChangeDir = this.handleChangeDir.bind(this);
  }

  componentWillMount() {
    const {
      getGatewayData,
      gatewayId,
    } = this.props;
    const { dir } = this.state;
    getGatewayData(gatewayId, { dir, limit: 20 });
  }

  componentWillReceiveProps(nextProps) {
    const { gatewayData } = nextProps;

    if (gatewayData !== this.props.gatewayData) {
      this.setState({ gatewayData });
      if (gatewayData.status === 'success') {
        this.setState({ dataList: gatewayData.data.list });
      }
    }
  }

  handleChangeDir(dir) {
    if (this.state.dir === dir) {
      return;
    }
    this.setState({ dir });

    const { gatewayId, getGatewayData } = this.props;
    getGatewayData(gatewayId, { dir, limit: 20 });
  }

  render() {
    const { gatewayId, pushState, getGatewayData } = this.props;
    const { gatewayData, dir, dataList = [], expanded = true } = this.state;
    const { status } = gatewayData;

    const header = (
      <div>
        {this.intlMsg.msg('latestdata.header')}
        <ul className="icontools">
          <li>
            <DetailEye onClick={() => pushState(`/gateway/detail/${gatewayId}/datamsg`)} />
          </li>
          <li>
            <Refresher
              reloading={status === 'pending'}
              onReload={() => getGatewayData(gatewayId, { dir, limit: 20 })}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={(v) => { this.setState({ expanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    const dataDirSwitch = (
      <DataDirSwitch onChange={this.handleChangeDir} />
    );

    const rows = dataList.map(d => (
      <tr key={`${d.$time}-${d.deveui}-${d.fcnt}`} className={isNew(d.$time) ? styles.new : ''}>
        <td className={styles.compact}>{compactFormat(d.$time)}</td>
        <td className={styles.compact}>
          <Link to={`/application/${d.appeui}`}>
            {normalizeAppEUI(d.appeui)}
          </Link>
        </td>
        <td className={styles.compact}>
          <Link to={`/application/${d.appeui}/devices/${d.deveui}`}>
            {normalizeDevEUI(d.deveui)}
          </Link>
        </td>
        <td>
          <Link to={`/application/${d.appeui}/devices/${d.deveui}`}>
            {d.name}
          </Link>
        </td>
        <td>
          <RichLabel
            content={d.mtype}
            translateMap={{
              UnconfirmedDataUp: this.intlMsg.msg('unconfirmeddataup'),
              UnconfirmedDataDown: this.intlMsg.msg('unconfirmeddatadown'),
              ConfirmedDataUp: this.intlMsg.msg('confirmeddataup'),
              ConfirmedDataDown: this.intlMsg.msg('confirmeddatadown'),
              JoinRequest: this.intlMsg.msg('joinrequest'),
              JoinAccept: this.intlMsg.msg('joinaccept'),
              RFU: this.intlMsg.msg('rfu'),
              Proprietary: this.intlMsg.msg('proprietary'),
            }}
          />
        </td>
        <td>{d.fcnt}</td>
      </tr>
    ));

    return (
      <Panel bsStyle="aisz-white" header={header} collapsible expanded={expanded}>
        <div>
          <PanelToolbar tools={[dataDirSwitch]} />
          <Table className={`aisz-table-light ${styles.dataTable}`} striped hover bordered responsive>
            <thead>
              <tr>
                <th> {this.intlMsg.msg('data.field.time', 'lora')} </th>
                <th> AppEUI </th>
                <th> DevEUI </th>
                <th> {this.intlMsg.msg('data.field.devname', 'lora')}</th>
                <th> {this.intlMsg.msg('data.field.msgtype', 'lora')} </th>
                <th> {this.intlMsg.msg('data.field.frameno', 'lora')} </th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
      </Panel>
    );
  }
}

BriefGatewayData.propTypes = propTypes;

const mapStateToProps = state => ({
  gatewayData: state.gateway.gatewayData,
});

const mapDispatchToProps = {
  getGatewayData: gatewayActions.gatewayData,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BriefGatewayData));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/BriefGatewayData/index.jsx